'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, type PropsWithChildren, useContext, useId } from 'react';
import { type DeviceLocationSource, getBrowserDeviceLocation } from './device-location-source.ts';
type DeviceLocationContextValue = {
  /** Scopes the cached device location to its source. */
  key: string;
  source: DeviceLocationSource;
};
const DeviceLocationContext = createContext<DeviceLocationContextValue>({
  key: 'browser',
  source: getBrowserDeviceLocation
});

/** Replaces the browser Geolocation API, e.g. with a fixed or denied location in tests. */
export const DeviceLocationProvider = t0 => {
  const $ = _c(6);
  const {
    children,
    source
  } = t0;
  const t1 = useId();
  let t2;
  if ($[0] !== source || $[1] !== t1) {
    t2 = {
      key: t1,
      source
    };
    $[0] = source;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <DeviceLocationContext value={t2} data-sentry-element="DeviceLocationContext" data-sentry-component="DeviceLocationProvider" data-sentry-source-file="device-location.tsx">{children}</DeviceLocationContext>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export const useDeviceLocation = () => {
  return useContext(DeviceLocationContext);
};